import React from 'react';
import { t } from '../../../../services/i18nService';

import MessagePending from '../preChecks/MessagePending';

function computeProps() {
    return {
        message: t('idVerification.similarity.PENDING_AUTOMATIC'),
    };
}

function SimilarityCheckPending(props) {
    const newProps = computeProps();

    return <MessagePending {...props} {...newProps} />;
}

export default SimilarityCheckPending;
